export default "__VITE_ASSET__6908ef2b__"